/*
 * Horgászkellék — „Több megjelenítése” a kategóriaoldalon (snippets/hk-load-more.liquid).
 * A gomb a következő oldal linkje; kattintásra a szekciót a Section Rendering API-val kérjük
 * le arról az oldalról, a termékeit a rács végére fűzzük, a gombot és az állapotsort a
 * válaszbeli újra cseréljük (az utolsó oldal után eltűnik). Hiba esetén a link a szokásos
 * módon a következő oldalra visz. A szűrők (facets.js) a teljes rácsot újrarajzolják, ezért
 * a kattintást a dokumentumon figyeljük.
 */
(() => {
  if (window.hkLoadMoreReady) return;
  window.hkLoadMoreReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('a.hk-load-more__button');
    if (!button || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const wrapper = button.closest('.hk-load-more');
    const grid = document.getElementById('product-grid');
    if (!wrapper || !grid) {
      window.location.href = button.href;
      return;
    }
    const hadFocus = document.activeElement === button;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    button.querySelector('.hk-load-more__spinner')?.classList.remove('hidden');

    try {
      const url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', wrapper.dataset.sectionId);
      const response = await fetch(url.toString());
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = doc.querySelectorAll('#product-grid > .grid__item');
      if (!items.length) throw new Error('üres oldal');
      const firstNew = items[0];
      grid.append(...items);
      const next = doc.querySelector('.hk-load-more');
      if (next) {
        next.querySelector('script')?.remove();
        wrapper.replaceWith(next);
        if (hadFocus) next.querySelector('a')?.focus({ preventScroll: true });
      } else {
        wrapper.remove();
        if (hadFocus) firstNew.querySelector('a')?.focus({ preventScroll: true });
      }
    } catch (error) {
      console.error('Több megjelenítése:', error);
      window.location.href = button.href;
    }
  });
})();
